export class UmDashboardCounts {
  myAssignments!: number;
  overdueAuths!: number;
  dueToday!: number;
  physicianReview!: number;
  awaitingInfo!: number;
  taskCount!: number;
}
